import { render, staticRenderFns } from "./InputKeyValuePairs.vue?vue&type=template&id=0f0388f4&"
import script from "./InputKeyValuePairs.vue?vue&type=script&lang=js&"
export * from "./InputKeyValuePairs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports